/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description:
 * @Date: 2020-06-30 21:01:53
 */

export const ORIGIN_CLIENT = process.env.CLIENT ? '' : `http://127.0.0.1:${process.env.PORT || 8302}`;

// common
export const UPDATE_LOADING_FINISHED = 'UPDATE_LOADING_FINISHED';

// 更新head中title和meta信息
export const UPDATE_HEAD = 'UPDATE_HEAD';

// 电影、电视剧、综艺、动漫 详情页
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const UPDATE_PLAYINFOINDEX = 'UPDATE_PLAYINFOINDEX';
export const UPDATE_ADV = 'UPDATE_ADV';
export const UPDATE_FINISH_EPISODE = 'UPDATE_FINISH_EPISODE';

// 搜索结果页
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const UPDATE_SEARCH_SHORTVIDEO = 'UPDATE_SEARCH_SHORTVIDEO';
export const UPDATE_SEARCH_VIDEO_PLDTIMES = 'UPDATE_SEARCH_VIDEO_PLDTIMES';
export const UPDATE_SEARCH_VIDEO_PLDPROGRESS = 'UPDATE_SEARCH_VIDEO_PLDPROGRESS';
export const UPDATE_SEARCH_VIDEO_STATUS = 'UPDATE_SEARCH_VIDEO_STATUS';
export const UPDATE_SEARCH_SPVER = 'UPDATE_SEARCH_SPVER';
export const UPDATE_SEARCH_MAXEND = 'UPDATE_SEARCH_MAXEND';
export const UPDATE_SEARCH_STEXP_INFO = 'UPDATE_SEARCH_STEXP_INFO';
export const UPDATE_SEARCH_PAGE = 'UPDATE_SEARCH_PAGE';
export const UPDATE_SEARCH_SUUID = 'UPDATE_SEARCH_SUUID';
export const UPDATE_SEARCH_ORIGIN_RESULT = 'UPDATE_SEARCH_ORIGIN_RESULT';
export const UPDATE_SEARCH_DEBUG_INFO = 'UPDATE_SEARCH_DEBUG_INFO';

// 明星详情页
export const UPDATE_STAR_QUERY = 'UPDATE_STAR_QUERY';
export const UPDATE_STAR_SEARCH_DATA = 'UPDATE_STAR_SEARCH_DATA';
export const UPDATE_STAR_ENTITY = 'UPDATE_STAR_ENTITY';
export const UPDATE_STAR_TAB = 'UPDATE_STAR_TAB';
export const UPDATE_STAR_BLACK_INFO = 'UPDATE_STAR_BLACK_INFO';

// 列表页
export const UPDATE_LIST_RESULT = 'UPDATE_LIST_RESULT';
export const UPDATE_LIST_CONFIG = 'UPDATE_LIST_CONFIG';

// playList
export const UPDATE_DATA = 'UPDATE_DATA';

// qlist
export const UPDATE_CONFIG = 'UPDATE_CONFIG';

// hotsugg
export const UPDATE_HOTSUGG_DATA = 'UPDATE_HOTSUGG_DATA';

// summary
export const UPDATE_SUMMARY_DATA = 'UPDATE_SUMMARY_DATA';
export const UPDATE_SUMMARY_PAGEMETA = 'UPDATE_SUMMARY_PAGEMETA';

// 首页
export const UPDATE_HOME_SPVER = 'UPDATE_HOME_SPVER';

// up主详情页
export const UPDATE_UPLOADER_HEAD = 'UPDATE_UPLOADER_HEAD';
export const UPDATE_UPLOADER_ITEM = 'UPDATE_UPLOADER_ITEM';

// 信息流视频
export const UPDATE_VIDEO_INFO = 'UPDATE_VIDEO_INFO';

